/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosLink } from "@components/elements/atoms";
import { useMessages } from "@epic-mw/i18n";
import { AuthBoxProps } from "./AuthBox";
import { linkStyles } from "./AuthBox.styles";
import { useSearchParams } from "next/navigation";
import { isSameOrigin } from "@cosmos/common-utils";

export const AuthBoxSignUp = (props: AuthBoxProps): React.JSX.Element => {
	const messages = useMessages();
	const searchParams = useSearchParams();

	const state = searchParams.get("state") || searchParams.get("redirectUrl") || "";

	const sameOrigin = isSameOrigin(state);
	const query: { state?: string } = {};
	if (sameOrigin) {
		query.state = state;
	}
	const signUpHref = `${props.origin}/register`;
	const signupUrl = new URL(signUpHref);

	return (
		<CosmosLink
			href={{
				host: signupUrl.host,
				pathname: signupUrl.pathname,
				query,
			}}
			className={linkStyles}
			target="_self"
			analytics={{
				eventCategory: "hyperlink",
				eventLabel: messages["epic.cosmos.auth.signup.link"] || "",
				eventValue: {
					component: "AuthBox",
					signUpHref,
				},
			}}
		>
			{messages["epic.cosmos.auth.signup.link"]}
		</CosmosLink>
	);
};
